import formatCurrency, { formatPurse } from "@tvg/formatter/currency";
import { formatPastRaceDate } from "@tvg/formatter/dates";
import { BetBasicInfo } from "@tvg/ts-types/Bet";
import { RaceProgram, RaceWagerType } from "@tvg/ts-types/Race";
import { getBettingInfo } from "@tvg/desktop-bet/src/utils/betUtils";
import { getValidRunnerId } from "@tvg/utils/betSelection";
import { get } from "lodash";
import { Selections } from "@tvg/ts-types/Selections";

import { BlacklistedWagerTypes } from "./types";
import { CURRENCY_THRESHOLD } from "./constants";

export const formatCurrencyTotal = (
  value: number,
  threshold: number = CURRENCY_THRESHOLD
) => (value <= threshold ? formatCurrency(value) : formatPurse(value));

export const getBetValue = (
  trackCode: string,
  raceNumber: string,
  postTime: string
) => {
  const postDate = formatPastRaceDate(postTime);
  return `${postDate}|${trackCode}|${raceNumber}`;
};

export const getTotalWinAmount = (raceWagers: BetBasicInfo[]) =>
  raceWagers.reduce(
    (accumulator, currentValue) =>
      accumulator + (currentValue.totalWinAmount ?? 0),
    0
  );

export const getIsBetRepeatable = (
  wager: BetBasicInfo,
  race: RaceProgram,
  races: Array<RaceProgram>,
  typeFromRace: RaceWagerType | undefined,
  blacklistedBets: BlacklistedWagerTypes
) => {
  const wagerSelections = get(wager, "selections.selection");

  const validSelections = wagerSelections.map((selection: Selections) =>
    getValidRunnerId(selection.bettingInterests)
  );

  const { totalAmount: totalFilteredAmount } = getBettingInfo(
    validSelections,
    wager.wagerAmount,
    race,
    races,
    typeFromRace
  );

  const isBlacklistedType =
    blacklistedBets.blacklistedBets &&
    blacklistedBets.blacklistedBets.includes(wager.wagerType.code);

  return isBlacklistedType ? false : Number(totalFilteredAmount) > 0;
};
